export default __webpack_public_path__ + "static/media/filterRemark.2b473c7e.svg";